<template>
  <v-footer id="subscribe">
    <v-snackbar
      v-model="showSnackbar"
      color="surface"
      :style="{ bottom: `20px` }"
      absolute
      bottom
      :timeout="5000"
    >
      {{ snackbarText }}
      <!-- <v-icon color="secondary" size="large" class="mt-n1 mr-2">{{ snackbarIcon }}</v-icon> -->
      <template v-slot:actions>
        <v-btn
          variant="text"
          @click="snackbar = false"
        >
          <v-icon color="primary" size="large" class="mt-n1 mr-2">{{ snackbarIcn }}</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-container class="py-6 px-4 ma-0" fluid>
      <v-row>
        <v-col cols="6">
        </v-col>
        <v-col cols="6" class="text-right">
          <span>A <a href="https://missionsquad.ai" target="_blank">Mission Squad</a> agent.</span>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>
<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { mapState } from 'vuex'
// import { submitEmail } from '@/utils/api'
// import { checkEmail } from '@/utils/general'

@Options({
  computed: {
    ...mapState(['snackbarVisible', 'snackbarMessage', 'snackbarIcon']),
    breakpoint() {
      return this.$vuetify.display.name
    }
  },
  watch: {
    breakpoint(value: any) {
      // this.hide()
    }
  }
})
export default class FooterComponent extends Vue {
  public breakpoint!: string

  public snackbarVisible!: boolean
  public snackbarMessage!: string
  public snackbarIcon!: string
  public snackbar = false

  get showSnackbar() {
    return this.snackbarVisible ?? false
  }

  set showSnackbar(value: boolean) {
    if (!value) {
      this.$store.commit('hideSnackbar')
    }
  }

  get snackbarText() {
    return this.snackbarMessage ?? ''
  }

  get snackbarIcn() {
    return this.snackbarIcon ?? 'mdi-thumb-up'
  }

  shouldHide(cols: string[]) {
    const bp = this.breakpoint ?? ''
    if (cols.includes(bp)) {
      return false
    }
    return true
  }
  
  shouldShow(cols: string[]) {
    const bp = this.breakpoint ?? ''
    if (cols.includes(bp)) {
      return true
    }
    return false
  }
}
</script>
<style lang="scss">
.cr {
  font-size: 12px;
  text-align: right;
}
.align-right {
  text-align: right;
}
</style>